import React, { useState, useEffect, useCallback, useRef } from 'react';
import './NewWorldDbSearch.css';

const NewWorldDbSearch = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef(null);

  const debounce = (func, wait) => {
    let timeout;
    const debounced = function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
    debounced.cancel = () => {
        clearTimeout(timeout);
    };
    return debounced;
  }

  // Debounce search term
  const debouncedOnSearch = useCallback(
    debounce((value) => onSearch(value), 300),
    [onSearch]
  );

  useEffect(() => {
    debouncedOnSearch(searchTerm);
    return () => {
      debouncedOnSearch.cancel();
    };
  }, [searchTerm, debouncedOnSearch]);

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleIconClick = () => {
    setIsExpanded(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 150); // wait for animation
  };

  const handleBlur = () => {
    if (!searchTerm) {
      setIsExpanded(false);
    }
  };
  
  return (
    <div className={`new-world-db-search-container ${isExpanded || searchTerm ? 'expanded' : ''}`}>
       <div className="new-world-db-search-icon" onClick={handleIconClick}>
         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm0-14a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" fill="currentColor"/>
            <path d="M21.707 20.293l-4-4a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414-1.414z" fill="currentColor"/>
         </svg>
       </div>
      <input
        ref={inputRef}
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleChange}
        onBlur={handleBlur}
        className="new-world-db-search-input"
      />
    </div>
  );
};

export default NewWorldDbSearch; 